// src/components/CardBrandIcon.jsx
import visaUrl from "../assets/cards/visa.svg";
import mcUrl from "../assets/cards/mastercard.svg";
import amexUrl from "../assets/cards/amex.svg";
import discUrl from "../assets/cards/discover.svg";
import cardUrl from "../assets/cards/generic-card.svg";

const MAP = {
  visa: visaUrl,
  mastercard: mcUrl,
  amex: amexUrl,
  discover: discUrl,
  card: cardUrl, // fallback
};

export default function CardBrandIcon({ brand = "card", className = "w-10 h-6" }) {
  const src = MAP[brand] || MAP.card;
  const label = brand === "card" ? "Card" : brand[0].toUpperCase() + brand.slice(1);
  return (
    <img
      src={src}
      alt={`${label} logo`}
      className={`${className} object-contain select-none`}
      width={40}
      height={24}
      draggable="false"
    />
  );
}
